import { render, staticRenderFns } from "./ModalCreateOrEdit.vue?vue&type=template&id=3f8d42bd"
import script from "./ModalCreateOrEdit.vue?vue&type=script&lang=js"
export * from "./ModalCreateOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports